module.exports = __webpack_public_path__ + "static/media/10.ddc83e71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/10.jpg
// module id = 543
// module chunks = 0